// extracted by mini-css-extract-plugin
export default {"container":"AddRandomQuestions__container___Lg86E","numberInput":"AddRandomQuestions__numberInput___Md32l"};